// Thin fetch wrapper that:
//   - Prefixes /api (Vite dev proxy → Functions emulator; prod → Hosting rewrite).
//   - Attaches Firebase ID token if a user is signed in.
//   - Unwraps the standard ApiResponse envelope and throws on errors.
import type { ApiResponse } from '@/types/models';
import { auth } from './client';

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message);
  }
}

async function authHeader(): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(await authHeader()),
    ...((init.headers as Record<string, string>) ?? {}),
  };

  const res = await fetch(`/api${path}`, { ...init, headers });
  const json = (await res.json()) as ApiResponse<T>;

  if (!json.ok) {
    throw new ApiError(res.status, json.error.code, json.error.message);
  }
  return json.data;
}
